import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=30e2a1a2&"
import script from "./disclaimer.vue?vue&type=script&lang=js&"
export * from "./disclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('30e2a1a2', component.options)
    } else {
      api.reload('30e2a1a2', component.options)
    }
    module.hot.accept("./disclaimer.vue?vue&type=template&id=30e2a1a2&", function () {
      api.rerender('30e2a1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/disclaimer/disclaimer.vue"
export default component.exports